import React from 'react';
import {AllRoles} from "../../components";

const Roles = () => {
    return <AllRoles/>
};

export default Roles;